import React, { useEffect, useRef, useState } from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { analyticsService } from 'utils/services/analytics'

import {
  MobileAppReason,
  Question,
  RequestedFeature,
  SURVEY_CLOSE_DELAY_MS,
  SurveyTextsByQuestion,
} from './constants'
import { SuccessScreen } from './SuccessScreen'
import { UserInput } from './UserInput'

import cm from './MobileBanner.module.css'

interface SurveyProps {
  closeBanner: () => void
}

export const Survey = ({ closeBanner }: SurveyProps) => {
  const [activeQuestion, setActiveQuestion] = useState(Question.REASON)
  const [isUserInputEnabled, setIsUserInputEnabled] = useState(false)
  const [isSuccessScreenVisible, setIsSuccessScreenVisible] = useState(false)
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (timeoutId.current) clearTimeout(timeoutId.current)
    },
    [],
  )

  const goBack = () => {
    setIsUserInputEnabled(false)
  }

  const showSuccessScreen = () => {
    setIsSuccessScreenVisible(true)
    timeoutId.current = setTimeout(closeBanner, SURVEY_CLOSE_DELAY_MS)
  }

  const handleUserInputSend = (userInput: string) => {
    analyticsService.sendEvent('MOBILE_BANNER.SURVEY.ANSWER', {
      question: activeQuestion,
      answer: 'another',
      userInput,
    })
    showSuccessScreen()
  }

  const handleBtnClick = (answer: {
    value: MobileAppReason | RequestedFeature
    label: ReturnType<typeof l.makeTranslate>
    nextQuestion?: Question
    isUserInputAvailable?: boolean
  }) => {
    if (answer.nextQuestion) {
      setActiveQuestion(answer.nextQuestion)
    } else if (answer.isUserInputAvailable) {
      setIsUserInputEnabled(true)
    } else {
      analyticsService.sendEvent('MOBILE_BANNER.SURVEY.ANSWER', {
        question: activeQuestion,
        answer: answer.value,
      })
      showSuccessScreen()
    }
  }

  if (isSuccessScreenVisible) return <SuccessScreen />
  if (isUserInputEnabled) {
    return <UserInput goBack={goBack} onSend={handleUserInputSend} />
  }

  const { title, description, answers } = SurveyTextsByQuestion[activeQuestion]

  return (
    <div className={cm.surveyContainer}>
      <h1>{l.getString(title)}</h1>
      {description && <p className="m-t-xs">{l.getString(description)}</p>}

      <div className="m-t-xl">
        {answers.map((answer, index) => (
          <BtnV2 fullWidth key={index} className="m-b-sm" onClick={() => handleBtnClick(answer)}>
            {l.getString(answer.label)}
          </BtnV2>
        ))}
      </div>
    </div>
  )
}
